import React from 'react';
import { motion } from 'framer-motion';

// This page shows ALL gallery images in justified layout
import Gallery from './Gallery';

const AllGalleryPage: React.FC = () => {
  return (
  <div className="min-h-[80vh] md:min-h-screen bg-gradient-to-br from-mini-red via-white to-mini-green dark:bg-gray-950">
      <div className="max-w-6xl mx-auto py-10 px-4">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl font-bold mb-8 text-center text-gray-900 dark:text-white"
        >
          Full Restoration Gallery
        </motion.h1>
        <Gallery showAll />
      </div>
    </div>
  );
};

export default AllGalleryPage;
